export class RegionRestrictions {
  id: number;
  regionID: number;
  userID: number;
  isInterval: boolean;
  startDate: string='';
  endDate: string='';
  sDate: Date;
  eDate: Date;
  duration: number;
}
